import { createFileRoute } from "@tanstack/react-router"
import { PageRequest } from "../../../@client/Theasoft_ApiServer__Utils_Pagination.ts"
import { ResourceObjectPageRequest } from "@/orval/gen/model/index.ts"
import { ResourceObjectsPage } from "./-components/ResourceObjectsPage.tsx"

export const Route = createFileRoute("/app/resources/resource-objects")({
  component: ResourceObjectsPage,
  beforeLoad: ({ context: { t } }) => ({
    getTitle: () => t && t("Resources_Title"),
  }),
  validateSearch: (
    search: Omit<ResourceObjectPageRequest, keyof PageRequest>
  ) => ({
    ...search,
    filter: { ...search.filter, available: search.filter?.available ?? true },
  }),
})
